import { render, staticRenderFns } from "./CourseCardfavorite.vue?vue&type=template&id=68eb18b9&scoped=true"
import script from "./CourseCardfavorite.vue?vue&type=script&lang=js"
export * from "./CourseCardfavorite.vue?vue&type=script&lang=js"
import style0 from "./CourseCardfavorite.vue?vue&type=style&index=0&id=68eb18b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eb18b9",
  null
  
)

export default component.exports